<template>
	<img class="welcome" src="../../../static/img/wo.png" />
</template>

<script>
export default {
  name: 'Welcome',
  meta:{page:true},
  created() {
  	setTimeout(() => {
    	this.$router.go(-1);//返回上一层
	}, 3000);
  },
}
</script>

<style>
	.welcome{
		width: 100%;
	    height: 100%;
	    position: absolute;
	    z-index: 2;
	}
</style>


// WEBPACK FOOTER //
// src/components/page/Welcome.vue